import { render, staticRenderFns } from "./CompanyAccountStatementModal.vue?vue&type=template&id=0b45a63c"
import script from "./CompanyAccountStatementModal.vue?vue&type=script&lang=js"
export * from "./CompanyAccountStatementModal.vue?vue&type=script&lang=js"
import style0 from "./CompanyAccountStatementModal.vue?vue&type=style&index=0&id=0b45a63c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports